import { RERA_FALLBACK_TEXT } from "../constants/businessInfo";

const PropertyDetails = ({ property }) => {
  if (!property) return null;

  const details = [
    { label: "Super Built-up Area", value: property.superBuiltUpArea, unit: "sq.ft" },
    { label: "Carpet Area", value: property.carpetArea, unit: "sq.ft" },
    { label: "Configuration", value: property.configuration },
    { label: "Facing", value: property.facing },
    { label: "Floor", value: property.floor },
    { label: "Ownership", value: property.ownership },
    { label: "Parking", value: property.parking },
    { label: "Possession", value: property.possession },
  ];

  const visibleDetails = details.filter(d => d.value);

  const reraDetails = [
    { label: "Developer Name", value: property.developerName },
    { label: "Project RERA Number", value: property.projectReraNumber },
    { label: "RERA Authority", value: property.reraAuthority },
    { label: "Project Status", value: property.projectStatus },
    { label: "Possession Date", value: property.possessionDate },
    { label: "Official Project Website", value: property.projectWebsite },
  ].filter((item) => item.value);

  if (!visibleDetails.length && !reraDetails.length) return null;

  return (
    <section className="max-w-7xl mx-auto p-4">
      {!!visibleDetails.length && <h2 className="text-lg font-semibold mb-4">Property Details</h2>}

      {!!visibleDetails.length && (
        <div className="bg-white p-6 rounded-xl shadow-sm grid md:grid-cols-2 gap-4 text-sm">
          {visibleDetails.map((item, i) => (
            <div key={i} className="flex justify-between border-b pb-2">
              <span className="text-gray-500">{item.label}</span>
              <span className="font-medium">
                {item.value} {item.unit || ""}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="mt-6 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-slate-900">Project Information</h3>

        {reraDetails.length > 0 ? (
          <div className="mt-4 grid md:grid-cols-2 gap-4 text-sm">
            {reraDetails.map((item) => (
              <div key={item.label} className="flex justify-between border-b pb-2 gap-3">
                <span className="text-slate-500">{item.label}</span>
                {item.label === "Official Project Website" ? (
                  <a
                    href={item.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-blue-700 hover:underline break-all text-right"
                  >
                    Visit Website
                  </a>
                ) : (
                  <span className="font-medium text-right">{item.value}</span>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-3 text-sm text-slate-600">{RERA_FALLBACK_TEXT}</p>
        )}
      </div>
    </section>
  );
};

export default PropertyDetails;
